import { Link } from 'react-router-dom';
import Button from '../global/Button';

type QuickReminderCardProps = {
  icon: string;
  title: 'Register Your Business!' | 'Update Your profile';
  desc: string;
  btnText: string;
  className?: string;
  disabled?: boolean;
};

const QuickReminderCard = ({
  icon,
  title,
  desc,
  btnText,
  className,
  disabled,
}: QuickReminderCardProps) => {
  return (
    <div
      style={{ border: '1px solid #DDDDDD', borderRadius: '20px' }}
      className={`mb-[19px] pb-10 h-52 lg:mb-auto px-[30px] pt-[20px] lg:w-[44%] bg-[#f8b40033] ${className}`}
    >
      <h2 className='font-bold text-lg text-green font-poppins mb-3'>{title}</h2>
      <p className='text-xs font-poppins text-black font-normal '>{desc}</p>
      <div className='flex justify-between   items-center'>
        <Link
          to={title === 'Update Your profile' ? '/settings/profile-information' : '/my-business'}
        >
          <Button
            size='xs'
            disabled={disabled}
            className='my-[31px] !bg-[#229698] w-[100%] text-center !text-[#FFFFFF] !border-0 !py-2 !px-[12px] mb-0 !rounded-[6px]'
          >
            {btnText}
          </Button>
        </Link>
        {/* } */}

        <div className='mb-4 md:!mb-[0px]'>
          <img src={icon} alt='cac-icon' />
        </div>
      </div>
    </div>
  );
};

export default QuickReminderCard;
